export enum ESpecialGamesType {
    RESPINS = 1,
    FREE_GAMES = 2,
    WILD_WALL = 3,
    LOCK_AND_ROLL = 4,
    BONUS_PICK = 5
}

export enum ESpecialGamesSymbolDrawAnimationType {
    CLASSIC = 'CLASSIC',
    REEL = 'REEL'
}

export interface ISpecialGamesGameConfig {
    symbolDrawAnimationType?: ESpecialGamesSymbolDrawAnimationType;
    reelAnimationOptions?: {
        numberOfPlaceholderSlots: number;
        winningSlotIndex: number;
        randomIdsToSpin: number[];
        attachementPrefix: string;
        slotPrefix: string;
    };
    retriggerInfoDuration: number;
}
